import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/style.css'
import './assets/fonts/bright.css'
import './assets/fonts/satoshi/satoshi.css'

createApp(App).use(store).use(router).mount('#app')
